export const LIST_ROOMS = 'LIST_ROOMS';
export const ROOM_SUCCESS = 'ROOM_SUCCESS';
export const ROOM_ERROR = 'ROOM_ERROR';
